import React, { useState } from "react";
import InputGroup from './Utility/InputGroup';
import Notice from "./Utility/Notice";
import GoogleIcon from "./Utility/GoogleIcon";
import { Link, useNavigate } from 'react-router-dom';
import { signup, authWithGoogle } from "../../Backend/Auth/AuthService";

export default function SignUp({ setGlobalNotice }) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [notice, setNotice] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleEmailSignup = async (e) => {
        e.preventDefault();
        setError(null);
        setNotice(null);
        // Call signup with all three values
        const result = await signup(name, email, password);
        console.log("email",result)
        if (result.success) {
            setGlobalNotice({ 
                type: "success", 
                text: "Verification Link sent to your Email. Please verify your email address!" 
            });
            navigate('/', { replace: true }); 
        } else {
            console.error("Email login error:", error);
            setNotice({ type: "error", text: result.error });
            setError(result.error);
        }
    };
        const handleGoogleAuth = async () => {
            setLoading(true);
            setNotice(null);
            setError(null);
    
            const result = await authWithGoogle();
            if (!result.success) {
                setLoading(false);
                setNotice({ type: "error", text: result.error });
                setError(result.error);
            }
        };

    return (
        
        <div className="flex flex-col items-center justify-center min-h-screen p-6">
            <header className="text-center mb-5">
                <h1 className="text-4xl font-bold tracking-wide">okul.live</h1>
                {notice && (
                <Notice 
                    type={notice.type} 
                    className="mt-4"
                    onClose={() => setNotice(null)} // Local notice is also dismissible
                >
                    {notice.text}
                </Notice>
                )}
            </header>
            
            <main className="w-full max-w-sm bg-white rounded-lg shadow-xl p-6">
                <h2 className="text-2xl font-semibold text-center mb-6">Create an Account</h2>

                <button
                    onClick={handleGoogleAuth}
                    className="btn-secondary w-full flex items-center justify-center gap-2"
                    disabled={loading}
                >
                    <GoogleIcon />
                    Sign up with Google
                </button>

                <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-300"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="bg-white px-2 text-gray-500">or</span>
                    </div>
                </div>
                <form onSubmit={handleEmailSignup} className="flex flex-col gap-4">
                    <InputGroup label="Name" id="name">
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder="Your full name"
                        />
                    </InputGroup>
                    <InputGroup label="Email" id="email">
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="you@example.com"
                        />
                    </InputGroup>
                    <InputGroup label="Password" id="password">
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength="6"
                            placeholder="At least 6 characters"
                        />
                    </InputGroup>
                    
                    <button type="submit" className="btn-primary" disabled={loading}>
                        {loading ? "Creating Account..." : "Sign Up"}
                    </button>
                </form>
                        
                
                <p className="text-center text-sm text-gray-600 mt-6">
                    Already have an account?{" "}
                    <button onClick={() => navigate('/login')} className="font-medium text-blue-600 hover:underline">
                        Log In
                    </button>
                </p>
            </main>
            <style>{`
                .btn-primary { margin-top: 6px; padding: 10px 14px; height: 44px; font-size: 16px; border-radius: 8px; border: none; cursor: pointer; background-color: #2563eb; color: #fff; transition: background-color 0.2s; }
                .btn-primary:hover { background-color: #1d4ed8; }
                .btn-primary:disabled { background-color: #93c5fd; cursor: not-allowed; }
                .btn-secondary { margin-top: 0; padding: 10px 14px; height: 44px; font-size: 16px; border-radius: 8px; border: 1px solid #d1d5db; cursor: pointer; background-color: #ffffff; color: #1f2937; transition: background-color 0.2s; }
                .btn-secondary:hover { background-color: #f9fafb; }
                input[type="text"], input[type="email"], input[type="password"] { height: 40px; padding: 8px 10px; font-size: 15px; border-radius: 6px; border: 1px solid #ddd; width: 100%; }
            `}</style>
        </div>
    );
}


    // const handleEmailSignUp = async (e) => {
    //     e.preventDefault();
    //     setLoading(true);
    //     try {
    //         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    //         const user = userCredential.user;
            
    //         // Create the user document in Firestore
    //         await createUserDocument(user, name);
            
    //         // Send verification email
    //         await sendEmailVerification(user);
            
    //         setGlobalNotice({ 
    //             type: "success", 
    //             text: "Account created! Please check your email to verify your account before logging in." 
    //         });
    //         setPage('login'); // Send to login page

    //     } catch (error) {
    //         console.error("Email signup error:", error);
    //         setNotice({ type: "error", text: error.message });
    //         setLoading(false);
    //     }
    // };